import React, { useEffect } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CloseIcon from '@material-ui/icons/Close';
import { useDispatch, useSelector } from 'react-redux';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import FormLabel from '@material-ui/core/FormLabel';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Checkbox from '@material-ui/core/Checkbox';
import FormHelperText from '@material-ui/core/FormHelperText';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { useTranslation } from 'react-i18next';
import DamageCodeAutocomplete from './DamageCodeAutocomplete';
import { decrementAnomaliesNumber } from '../EditTicket/EditTicketSlice';
import useStyles from './styles';
import FileUploader from './FileUploader/FileUploader';
import { userInfoState } from '../HomePage/HomeSlice';
import ApiService from '../../services/ApiService';

export default function AnomalyContent(props) {
  const {
    expanded,
    handleChange,
    saveClicked,
    validationError,
    anomaly,
    hasUniqueAnomaly,
    ticketStatus,
  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const user = useSelector(userInfoState);
  const [anomalyDate, setAnomalyDate] = React.useState(new Date());
  const [source, setSource] = React.useState(
    user.hasAllRights || user.hasEmilyDRights
      ? null
      : user.internal || user.externalMax
      ? 'total site'
      : 'client site',
  );
  const [origin, setOrigin] = React.useState(user.name);
  const [damagePlace, setDamagePlace] = React.useState(user.site);
  const [inputDamagePlace, setInputDamagePlace] = React.useState(null);

  const [detailedLocation, setDetailedLocation] = React.useState(null);

  const [labelK, setLabelK] = React.useState(false);
  const [labelM, setLabelM] = React.useState(false);
  const [labelI, setLabelI] = React.useState(false);
  const [labelR1, setLabelR1] = React.useState(false);
  const [labelU, setLabelU] = React.useState(false);

  const [appliedLabelK, setAppliedLabelK] = React.useState(false);
  const [appliedLabelM, setAppliedLabelM] = React.useState(false);
  const [appliedLabelI, setAppliedLabelI] = React.useState(false);
  const [appliedLabelR1, setAppliedLabelR1] = React.useState(false);
  const [appliedLabelU, setAppliedLabelU] = React.useState(false);
  const [transportPossibleErrorMessage, setTransportPossibleErrorMessage] =
    React.useState(null);
  const [transportPossible, setTransportPossible] = React.useState(null);
  const [sourceErrorMessage, setSourceErrorMessage] = React.useState(null);
  const [originErrorMessage, setOriginErrorMessage] = React.useState(null);
  const [creatorName, setCreatorName] = React.useState(user.name);
  const [creatorSite, setCreatorSite] = React.useState(user.site);
  const [descriptionErrorMessage, setDescriptionErrorMessage] =
    React.useState(null);
  const [damagePlaceErrorMessage, setDamagePlaceErrorMessage] =
    React.useState(null);
  const [anomalyDateErrorMessage, setAnomalyDateErrorMessage] =
    React.useState(null);
  const [damagePlaceList, setDamagePlaceList] = React.useState([]);

  const [appliedLabelWagonDetached, setAppliedLabelWagonDetached] =
    React.useState(false);

  const [description, setDescription] = React.useState(null);
  const [damages, setDamages] = React.useState([]);
  const [attachments, setAttachments] = React.useState([]);
  let attachmentsStateError = false;
  const isEditDisabled = ticketStatus === 'Ticket closed';

  const dateFormatter = (date) => {
    const isValidDate = Date.parse(date);
    if (Number.isNaN(isValidDate)) {
      return null;
    }
    const offset = date.getTimezoneOffset();
    date = new Date(date.getTime() - offset * 60 * 1000);
    return date.toISOString().split('T')[0];
  };

  const anomalyInformations = {
    index: anomaly ? anomaly.index : null,
    anomalyDate: dateFormatter(anomalyDate),
    source,
    origin,
    damagePlace: inputDamagePlace != null ? inputDamagePlace : damagePlace,
    detailedLocation,
    labelK,
    labelM,
    labelI,
    labelR1,
    labelU,
    appliedLabelK,
    appliedLabelM,
    appliedLabelI,
    appliedLabelR1,
    appliedLabelU,
    appliedLabelWagonDetached,
    transportPossible,
    description,
    damages,
    attachments,
    creatorName,
    creatorSite,
  };
  useEffect(() => {
    ApiService.getAllDamagePlaces().then((response) => {
      setDamagePlaceList(response.data.map((option) => option.name));
    });
  }, []);
  useEffect(() => {
    if (anomaly) {
      setAnomalyDate(new Date(anomaly.anomalyDate));
      setSource(anomaly.source);
      setOrigin(anomaly.origin);
      setDamagePlace(anomaly.damagePlace);
      setDetailedLocation(anomaly.detailedLocation);
      setLabelK(anomaly.labelK);
      setLabelM(anomaly.labelM);
      setLabelI(anomaly.labelI);
      setLabelR1(anomaly.labelR1);
      setLabelU(anomaly.labelU);
      setAppliedLabelK(anomaly.appliedLabelK);
      setAppliedLabelM(anomaly.appliedLabelM);
      setAppliedLabelI(anomaly.appliedLabelI);
      setAppliedLabelR1(anomaly.appliedLabelR1);
      setAppliedLabelU(anomaly.appliedLabelU);
      setAppliedLabelWagonDetached(anomaly.appliedLabelWagonDetached);
      setDescription(anomaly.description);
      setDamages(anomaly.damages);
      setAttachments(anomaly.attachments.slice());
      setCreatorName(anomaly.creatorName);
      setCreatorSite(anomaly.creatorSite);
      if (anomaly.transportPossible !== '-') {
        setTransportPossible(anomaly.transportPossible);
      }
    }
  }, [anomaly]);

  useEffect(() => {
    if (validationError) {
      if (validationError.anomalyDate !== undefined) {
        setAnomalyDateErrorMessage(validationError.anomalyDate);
      }
      if (validationError.source !== undefined) {
        setSourceErrorMessage(validationError.source);
      }
      if (validationError.origin !== undefined) {
        setOriginErrorMessage(validationError.origin);
      }
      if (validationError.damagePlace !== undefined) {
        setDamagePlaceErrorMessage(validationError.damagePlace);
      }
      if (validationError.description !== undefined) {
        setDescriptionErrorMessage(validationError.description);
      }
      if (validationError.transportPossible !== undefined) {
        setTransportPossibleErrorMessage(validationError.transportPossible);
      }
    }
  }, [validationError]);

  useEffect(() => {
    if (attachments.length > 0) {
      attachmentsStateError = false;
    }
  }, [attachments]);

  useEffect(() => {
    if (saveClicked) {
      if (attachmentsStateError === false) {
        props.setAnomalyInformations(anomalyInformations);
      }
    }
  }, [
    anomalyDate,
    source,
    origin,
    damagePlace,
    detailedLocation,
    labelK,
    labelM,
    labelI,
    labelR1,
    labelU,
    appliedLabelK,
    appliedLabelM,
    appliedLabelI,
    appliedLabelR1,
    appliedLabelU,
    appliedLabelWagonDetached,
    transportPossible,
    description,
    saveClicked,
    damages,
    attachments,
    attachmentsStateError,
  ]);

  function getDamageCodeList(damageCodes) {
    setDamages(damageCodes);
  }
  function cancelAnomaly() {
    dispatch(decrementAnomaliesNumber());
  }
  function getAttachments(files) {
    if (saveClicked) {
      setAttachments(files.slice());
      attachmentsStateError = true;
    }
  }
  function getAttachmentsWithFile(files) {
    if (saveClicked) {
      props.sendAttachmentWithFiles(files);
    }
  }
  function handleAnomalyDateErrorMessage(date) {
    const isValidDate = Date.parse(date);
    if (Number.isNaN(isValidDate)) {
      setAnomalyDateErrorMessage('');
    } else {
      setAnomalyDateErrorMessage(null);
    }
  }
  function resetDamageCodeValidationErrors() {
    props.resetValidationErrors('damageCode');
  }

  return (
    <Accordion
      className={classes.accordion}
      expanded={expanded}
      onChange={handleChange}
    >
      <AccordionSummary
        expandIcon={
          !anomaly && expanded && !hasUniqueAnomaly ? (
            <CloseIcon className={classes.expandIcon} onClick={cancelAnomaly} />
          ) : (
            <ExpandMoreIcon className={classes.expandIcon} />
          )
        }
        aria-controls="panel3a-content"
        id="panel3a-header"
      >
        <Typography className={classes.heading}> {t('Anomaly')}</Typography>
        <Typography className={classes.secondaryHeading}>
          {t('Anomaly Details')}
        </Typography>
      </AccordionSummary>
      <AccordionDetails style={{ display: 'block' }}>
        <div className={classes.description}>
          <span className={classes.asterisk}> * </span>
          {t('edit ticket description')}
        </div>
        <div className={classes.container}>
          <Grid container spacing={1} className={classes.gridMargin}>
            <Grid item xs={4}>
              <FormLabel className={classes.formLabel}>
                {t('Anomaly date')}
                {(user.hasAllRights ||
                  user.hasEmilyDRights ||
                  !anomaly ||
                  user.name === anomaly.creatorName) && (
                  <span className={classes.asterisk}> *</span>
                )}
              </FormLabel>
            </Grid>
            <Grid item xs={4}>
              <FormLabel className={classes.formLabel}>
                {t('Source type')}
                {(user.hasAllRights || user.hasEmilyDRights) && (
                  <span className={classes.asterisk}> *</span>
                )}
              </FormLabel>
            </Grid>
            <Grid item xs={4}>
              <FormLabel className={classes.formLabel}>
                {t('Anomaly Reporter')}
                {(user.hasAllRights ||
                  user.hasEmilyDRights ||
                  user.site === 'leuna') && (
                  <span className={classes.asterisk}> *</span>
                )}
              </FormLabel>
            </Grid>{' '}
            <Grid item xs={4}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disabled={
                    (anomaly &&
                      !user.hasAllRights &&
                      !user.hasEmilyDRights &&
                      user.name !== anomaly.creatorName) ||
                    isEditDisabled
                  }
                  className={classes.datePicker}
                  InputProps={{ className: classes.datePickerInput }}
                  disableToolbar
                  inputVariant="outlined"
                  format="dd/MM/yyyy"
                  margin="normal"
                  value={anomalyDate}
                  onChange={(date) => {
                    setAnomalyDate(date);
                    handleAnomalyDateErrorMessage(date);
                  }}
                  error={anomalyDateErrorMessage !== null}
                />
              </MuiPickersUtilsProvider>{' '}
              <FormHelperText className={classes.formHelperText}>
                {anomalyDateErrorMessage}
              </FormHelperText>
            </Grid>
            <Grid item xs={4}>
              {user.hasAllRights || user.hasEmilyDRights ? (
                <FormControl className={classes.formControl}>
                  <Select
                    variant="outlined"
                    displayEmpty
                    className={classes.select}
                    disabled={isEditDisabled}
                    inputProps={{ 'aria-label': 'Without label' }}
                    MenuProps={{ classes: { paper: classes.dropdownStyle } }}
                    value={source || ''}
                    onChange={(e) => {
                      setSource(e.target.value);
                      setSourceErrorMessage(null);
                      props.resetValidationErrors('source');
                    }}
                    error={sourceErrorMessage !== null}
                  >
                    <MenuItem value="" disabled>
                      {t('Select a source type')}
                    </MenuItem>
                    <MenuItem value="wdr"> {t('wdr')}</MenuItem>
                    <MenuItem value="total site">{t('total site')}</MenuItem>
                    <MenuItem value="client site">{t('client site')}</MenuItem>
                    <MenuItem value="others"> {t('others')}</MenuItem>
                  </Select>
                  <FormHelperText className={classes.formHelperText}>
                    {sourceErrorMessage}
                  </FormHelperText>
                </FormControl>
              ) : (
                <TextField
                  disabled
                  className={classes.input}
                  inputProps={{ style: { textTransform: 'capitalize' } }}
                  variant="outlined"
                  size="small"
                  value={t(source)}
                />
              )}
            </Grid>
            <Grid item xs={4}>
              <TextField
                disabled={
                  !(
                    user.hasAllRights ||
                    user.hasEmilyDRights ||
                    user.site === 'leuna'
                  ) || isEditDisabled
                }
                className={classes.input}
                variant="outlined"
                size="small"
                placeholder={t('Surname + First name or company name')}
                InputProps={{ classes: { input: classes.inputStyle } }}
                value={origin || ''}
                onChange={(e) => {
                  setOrigin(e.target.value);
                  setOriginErrorMessage(null);
                  if (originErrorMessage !== null)
                    props.resetValidationErrors('origin');
                }}
                error={originErrorMessage !== null}
                helperText={originErrorMessage}
              />
            </Grid>
          </Grid>
          {user.hasAllRights ||
          user.hasEmilyDRights ||
          user.site === 'leuna' ||
          user.externalMax ? (
            <Grid container spacing={1} className={classes.gridMargin}>
              <Grid item xs={4}>
                <FormLabel className={classes.formLabel}>
                  {t('Place of damage')}
                  {(user.hasAllRights || user.hasEmilyDRights) && (
                    <span className={classes.asterisk}> *</span>
                  )}
                </FormLabel>
              </Grid>
              <Grid item xs={4}>
                <FormLabel className={classes.formLabel}>
                  {t('Detailed Location')}
                </FormLabel>
              </Grid>
              <Grid item xs={4}>
                <FormLabel className={classes.formLabel}>
                  {t('Transport possible according to RID 4.3.2.4.3')}
                  {user.site === 'leuna' && (
                    <span className={classes.asterisk}> *</span>
                  )}
                </FormLabel>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={1} className={classes.gridMargin}>
              <Grid item xs={6}>
                <FormLabel className={classes.formLabel}>
                  {t('Place of damage')}
                  {(user.hasAllRights || user.hasEmilyDRights) && (
                    <span className={classes.asterisk}> *</span>
                  )}
                </FormLabel>
              </Grid>
              <Grid item xs={6}>
                <FormLabel className={classes.formLabel}>
                  {t('Detailed Location')}
                </FormLabel>
              </Grid>
            </Grid>
          )}
          {user.hasAllRights ||
          user.hasEmilyDRights ||
          user.site === 'leuna' ||
          user.externalMax ? (
            <Grid container spacing={1} className={classes.gridMargin}>
              <Grid item xs={4}>
                {user.hasAllRights || user.hasEmilyDRights ? (
                  <Autocomplete
                    disabled={isEditDisabled}
                    className={classes.damageplaceAutocomplete}
                    size="small"
                    freeSolo
                    required
                    options={damagePlaceList}
                    value={damagePlace}
                    getOptionLabel={(option) => option}
                    ListboxProps={{ style: { maxHeight: '15rem' } }}
                    renderOption={(option) => (
                      <>
                        <Typography className={classes.damagePlace}>
                          {option}
                        </Typography>
                      </>
                    )}
                    renderInput={(params) => (
                      <TextField
                        disabled={isEditDisabled}
                        error={damagePlaceErrorMessage !== null}
                        helperText={damagePlaceErrorMessage}
                        FormHelperTextProps={{ className: classes.helperText }}
                        {...params}
                        variant="outlined"
                        onChange={(e) => {
                          setInputDamagePlace(e.target.value);
                          setDamagePlaceErrorMessage(null);
                          props.resetValidationErrors('damagePlace');
                        }}
                      />
                    )}
                    onChange={(e, newValue) => {
                      setDamagePlace(newValue);
                      setDamagePlaceErrorMessage(null);
                      setInputDamagePlace(null);
                      props.resetValidationErrors('damagePlace');
                    }}
                  />
                ) : (
                  <TextField
                    disabled={
                      !user.hasAllRights ||
                      !user.hasEmilyDRights ||
                      isEditDisabled
                    }
                    className={classes.damageInput}
                    variant="outlined"
                    size="small"
                    placeholder={t('Enter place of damage')}
                    InputProps={{ classes: { input: classes.inputStyle } }}
                    value={damagePlace || ''}
                    onChange={(e) => {
                      setDamagePlace(e.target.value);
                      setDamagePlaceErrorMessage(null);
                      props.resetValidationErrors('damagePlace');
                    }}
                    error={damagePlaceErrorMessage !== null}
                    helperText={damagePlaceErrorMessage}
                    FormHelperTextProps={{ className: classes.helperText }}
                  />
                )}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  disabled={isEditDisabled}
                  className={classes.input}
                  variant="outlined"
                  size="small"
                  placeholder={t('Enter detailed location')}
                  InputProps={{ classes: { input: classes.inputStyle } }}
                  value={detailedLocation || ''}
                  onChange={(e) => {
                    setDetailedLocation(e.target.value);
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControl className={classes.formControl}>
                  <Select
                    disabled={isEditDisabled}
                    variant="outlined"
                    displayEmpty
                    className={classes.select}
                    inputProps={{ 'aria-label': 'Without label' }}
                    MenuProps={{ classes: { paper: classes.dropdownStyle } }}
                    value={transportPossible || ''}
                    onChange={(e) => {
                      setTransportPossible(e.target.value);
                      setTransportPossibleErrorMessage(null);
                      props.resetValidationErrors('transportPossible');
                    }}
                    error={transportPossibleErrorMessage !== null}
                  >
                    <MenuItem value="" disabled>
                      {' '}
                      {t('Select')}
                    </MenuItem>
                    <MenuItem value="yes"> {t('yes')}</MenuItem>
                    <MenuItem value="no">{t('no')}</MenuItem>
                  </Select>
                  <FormHelperText className={classes.formHelperText}>
                    {transportPossibleErrorMessage}
                  </FormHelperText>
                </FormControl>
              </Grid>
            </Grid>
          ) : (
            <Grid container spacing={1} className={classes.gridMargin}>
              <Grid item xs={6}>
                <TextField
                  disabled={
                    !user.hasAllRights ||
                    !user.hasEmilyDRights ||
                    isEditDisabled
                  }
                  className={classes.damageInput}
                  variant="outlined"
                  size="small"
                  placeholder={t('Enter place of damage')}
                  InputProps={{ classes: { input: classes.inputStyle } }}
                  value={damagePlace || ''}
                  onChange={(e) => {
                    setDamagePlace(e.target.value);
                    setDamagePlaceErrorMessage(null);
                    props.resetValidationErrors('damagePlace');
                  }}
                  error={damagePlaceErrorMessage !== null}
                  helperText={damagePlaceErrorMessage}
                  FormHelperTextProps={{ className: classes.helperText }}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  disabled={isEditDisabled}
                  className={classes.input}
                  variant="outlined"
                  size="small"
                  placeholder={t('Enter detailed location')}
                  InputProps={{ classes: { input: classes.inputStyle } }}
                  value={detailedLocation || ''}
                  onChange={(e) => {
                    setDetailedLocation(e.target.value);
                  }}
                />
              </Grid>
            </Grid>
          )}
          <Grid container spacing={1} className={classes.gridMargin}>
            <Grid item xs={5}>
              <FormLabel className={classes.formLabel}>
                {t('Label found on the wagon')}
              </FormLabel>
            </Grid>{' '}
            <Grid item xs={5}>
              <FormLabel className={classes.formLabel}>
                {t('Sample of labelling')}
              </FormLabel>
            </Grid>{' '}
            <Grid item xs={5}>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isEditDisabled}
                      className={classes.checkbox}
                      checked={labelK}
                      name="checkedLabelK"
                      onChange={() => {
                        setLabelK(!labelK);
                      }}
                    />
                  }
                  label={
                    <Typography className={classes.anomalyDetail}>K</Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isEditDisabled}
                      name="checkedLabelM"
                      className={classes.checkbox}
                      checked={labelM}
                      onChange={() => {
                        setLabelM(!labelM);
                      }}
                    />
                  }
                  label={
                    <Typography className={classes.anomalyDetail}>M</Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isEditDisabled}
                      name="checkedLabelI"
                      className={classes.checkbox}
                      checked={labelI}
                      onChange={() => {
                        setLabelI(!labelI);
                      }}
                    />
                  }
                  label={
                    <Typography className={classes.anomalyDetail}>I</Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isEditDisabled}
                      name="checkedLabelR1"
                      className={classes.checkbox}
                      checked={labelR1}
                      onChange={() => {
                        setLabelR1(!labelR1);
                      }}
                    />
                  }
                  label={
                    <Typography className={classes.anomalyDetail}>
                      R1
                    </Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isEditDisabled}
                      name="checkedLabelU"
                      className={classes.checkbox}
                      checked={labelU}
                      onChange={() => {
                        setLabelU(!labelU);
                      }}
                    />
                  }
                  label={
                    <Typography className={classes.anomalyDetail}>U</Typography>
                  }
                />
              </FormGroup>
            </Grid>
            <Grid item xs={7}>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isEditDisabled}
                      name="checkedLabelK"
                      className={classes.checkbox}
                      checked={appliedLabelK}
                      onChange={() => {
                        setAppliedLabelK(!appliedLabelK);
                      }}
                    />
                  }
                  label={
                    <Typography className={classes.anomalyDetail}>K</Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isEditDisabled}
                      name="checkedLabelM"
                      className={classes.checkbox}
                      checked={appliedLabelM}
                      onChange={() => {
                        setAppliedLabelM(!appliedLabelM);
                      }}
                    />
                  }
                  label={
                    <Typography className={classes.anomalyDetail}>M</Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isEditDisabled}
                      name="checkedLabelI"
                      className={classes.checkbox}
                      checked={appliedLabelI}
                      onChange={() => {
                        setAppliedLabelI(!appliedLabelI);
                      }}
                    />
                  }
                  label={
                    <Typography className={classes.anomalyDetail}>I</Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isEditDisabled}
                      name="checkedLabelR1"
                      className={classes.checkbox}
                      checked={appliedLabelR1}
                      onChange={() => {
                        setAppliedLabelR1(!appliedLabelR1);
                      }}
                    />
                  }
                  label={
                    <Typography className={classes.anomalyDetail}>
                      R1
                    </Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isEditDisabled}
                      name="checkedLabelU"
                      className={classes.checkbox}
                      checked={appliedLabelU}
                      onChange={() => {
                        setAppliedLabelU(!appliedLabelU);
                      }}
                    />
                  }
                  label={
                    <Typography className={classes.anomalyDetail}>U</Typography>
                  }
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isEditDisabled}
                      name="checkedLabelDetached"
                      className={classes.checkbox}
                      checked={appliedLabelWagonDetached}
                      onChange={() => {
                        setAppliedLabelWagonDetached(
                          !appliedLabelWagonDetached,
                        );
                      }}
                    />
                  }
                  label={
                    <Typography className={classes.anomalyDetail}>
                      {t('Detached wagon')}
                    </Typography>
                  }
                />
              </FormGroup>
            </Grid>
          </Grid>
          <Grid container spacing={1} className={classes.gridMargin}>
            <Grid item xs={12}>
              {' '}
              <FormLabel className={classes.formLabel}>
                {t('Damage codes')}
                <span className={classes.asterisk}> *</span>
              </FormLabel>
            </Grid>
            <Grid item xs={12}>
              <DamageCodeAutocomplete
                isDisabledField={isEditDisabled}
                validationError={validationError}
                setDamageCodeList={getDamageCodeList}
                damageList={damages}
                resetValidationErrors={resetDamageCodeValidationErrors}
              />
            </Grid>
          </Grid>

          <Grid container spacing={1} className={classes.gridMargin}>
            <Grid item xs={12}>
              <FormLabel className={classes.formLabel}>
                {t('Description')}
              </FormLabel>
            </Grid>
            <Grid item xs={12}>
              <TextField
                disabled={isEditDisabled}
                className={`${classes.ticketdetail} ${classes.warningMessage}`}
                fullWidth
                placeholder={t('Enter anomaly description')}
                multiline
                rows={3}
                InputProps={{
                  classes: { input: classes.inputStyle },
                }}
                variant="outlined"
                value={description || ''}
                onChange={(e) => {
                  setDescription(e.target.value.slice(0, 255));
                  setDescriptionErrorMessage(null);
                  props.resetValidationErrors('description');
                }}
                error={descriptionErrorMessage !== null}
                helperText={descriptionErrorMessage}
                FormHelperTextProps={{ className: classes.helperText }}
              />
            </Grid>
          </Grid>
          <FileUploader
            sendAttachmentWithFiles={getAttachmentsWithFile}
            sendAttachments={getAttachments}
            saveClicked={saveClicked}
            files={anomaly ? anomaly.attachments.slice() : []}
            anomalyIndex={anomaly ? anomaly.index : null}
          />
        </div>
      </AccordionDetails>
    </Accordion>
  );
}
